
  import countFilterWikis from '@/apollo/queries/wiki/countFilterWikis.gql';
  import filterWikis from '@/apollo/queries/wiki/filterWikis.gql';
  import WikiFilter from '@/components/WikiFilter';
  import WikiCard from '@/components/elements/WikiCard';
  import Pagination from '@/components/Pagination';
  import JobListingBanner from '@/components/elements/JobListingBanner';

  export default {
    name: 'SectionWikiListingWithFilter',
    components: {
      RichText: () => import('@/components/elements/RichText'),
      TeaseredWikisCard: () =>
        import('@/components/elements/TeaseredWikisCard'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
      WikiFilter,
      WikiCard,
      Pagination,
      JobListingBanner,
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        searchText: '',
        page: 1,
        countPages: 0,
        itemsPerPage: this.section.num_news_per_page,
        wikisCount: 0,
        orderBy: 'title:asc',
        loading: true,

        wikis: [],

        filterParams: {
          search_term: null,
          search_slug: [],
        },
      };
    },
    apollo: {
      wikis: {
        query: filterWikis,
        variables() {
          this.parsePageFromQuery();
          let searchTerm = [];
          if (this.filterParams.search_term) {
            const searchArray = this.filterParams.search_term.split(' ');
            searchTerm = this.removeEmptyStrings(searchArray);
          }
          return {
            sort: this.orderBy,
            limit: this.itemsPerPage,
            start: this.itemsPerPage * (this.page - 1),
            search_term: searchTerm,
            search_slug: this.filterParams.search_slug,
          };
        },
      },
      wikisCount: {
        query: countFilterWikis,
        variables() {
          let searchTerm = [];
          if (this.filterParams.search_term) {
            const searchArray = this.filterParams.search_term.split(' ');
            searchTerm = this.removeEmptyStrings(searchArray);
          }
          return {
            search_term: searchTerm,
            search_slug:
              this.filterParams.search_slug &&
              this.filterParams.search_slug.length > 0
                ? this.filterParams.search_slug
                : null,
          };
        },
        result({data}) {
          this.wikisCount = data.wikisCount.aggregate.count;
          this.countPages = Math.ceil(this.wikisCount / this.itemsPerPage);
          this.loading = false;
        },
      },
    },
    head() {
      const query = Object.assign({}, this.$route.query);
      const canonical_links = [];

      canonical_links.push({
        rel: 'canonical',
        hid: 'canonical',
        href:
          process.env.NUXT_ENV_BASE_URL +
          this.localePath({
            name: 'wikis',
            query: {page: this.page > 1 ? this.page : undefined},
          }),
      });

      if (this.page > 1) {
        query.page = this.page - 1;
        canonical_links.push({
          rel: 'prev',
          hid: 'prev',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      if (this.page < this.countPages) {
        query.page = this.page + 1;
        canonical_links.push({
          rel: 'next',
          hid: 'next',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      return {
        link: canonical_links,
      };
    },
    watch: {
      '$route.query': function () {
        this.parsePageFromQuery();
      },
    },
    methods: {
      removeEmptyStrings(array) {
        return array.filter((str) => str !== '');
      },
      parsePageFromQuery() {
        this.page = this.$route.query.page
          ? parseInt(this.$route.query.page)
          : 1;
      },
      pushRouter() {
        this.$router.push(this.localePath({}) + `?page=${this.page}`);
      },
      searchWiki(value) {
        this.filterParams = {
          search_term: value,
          search_slug: [],
        };
        this.page = 1;
      },
      searchByLetter(value) {
        this.filterParams = {
          search_term: null,
          search_slug: value,
        };
        this.page = 1;
      },
      resetWikiSearch() {
        this.filterParams = {
          search_term: null,
          search_slug: [],
        };
      },
    },
  };
